// extracted by mini-css-extract-plugin
module.exports = {"root":"_2YyJk","header":"_3FLCC","title":"VSO4u","cta":"_1dAAS","itemsWrapper":"_2fSmH","button":"_2_6ar","subtitle":"_3bx9n","blockWith4Items":"E88Fo"};